/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetPropertyRightResponse } from './AssetPropertyRightResponse';
import {
    AssetPropertyRightResponseFromJSON,
    AssetPropertyRightResponseFromJSONTyped,
    AssetPropertyRightResponseToJSON,
    AssetPropertyRightResponseToJSONTyped,
} from './AssetPropertyRightResponse';
import type { PropertyRightAnswersDto } from './PropertyRightAnswersDto';
import {
    PropertyRightAnswersDtoFromJSON,
    PropertyRightAnswersDtoFromJSONTyped,
    PropertyRightAnswersDtoToJSON,
    PropertyRightAnswersDtoToJSONTyped,
} from './PropertyRightAnswersDto';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * 
 * @export
 * @interface PropertyRightsTabResponse
 */
export interface PropertyRightsTabResponse {
    /**
     * 
     * @type {string}
     * @memberof PropertyRightsTabResponse
     */
    clientId: string;
    /**
     * 
     * @type {PropertyRightAnswersDto}
     * @memberof PropertyRightsTabResponse
     */
    answers: PropertyRightAnswersDto;
    /**
     * 
     * @type {AddressDto}
     * @memberof PropertyRightsTabResponse
     */
    homeAddress: AddressDto;
    /**
     * 
     * @type {Array<AssetPropertyRightResponse>}
     * @memberof PropertyRightsTabResponse
     */
    propertyRights: Array<AssetPropertyRightResponse>;
}

/**
 * Check if a given object implements the PropertyRightsTabResponse interface.
 */
export function instanceOfPropertyRightsTabResponse(value: object): value is PropertyRightsTabResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('answers' in value) || value['answers'] === undefined) return false;
    if (!('homeAddress' in value) || value['homeAddress'] === undefined) return false;
    if (!('propertyRights' in value) || value['propertyRights'] === undefined) return false;
    return true;
}

export function PropertyRightsTabResponseFromJSON(json: any): PropertyRightsTabResponse {
    return PropertyRightsTabResponseFromJSONTyped(json, false);
}

export function PropertyRightsTabResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyRightsTabResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'answers': PropertyRightAnswersDtoFromJSON(json['answers']),
        'homeAddress': AddressDtoFromJSON(json['homeAddress']),
        'propertyRights': ((json['propertyRights'] as Array<any>).map(AssetPropertyRightResponseFromJSON)),
    };
}

export function PropertyRightsTabResponseToJSON(json: any): PropertyRightsTabResponse {
    return PropertyRightsTabResponseToJSONTyped(json, false);
}

export function PropertyRightsTabResponseToJSONTyped(value?: PropertyRightsTabResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'answers': PropertyRightAnswersDtoToJSON(value['answers']),
        'homeAddress': AddressDtoToJSON(value['homeAddress']),
        'propertyRights': ((value['propertyRights'] as Array<any>).map(AssetPropertyRightResponseToJSON)),
    };
}

